/* src/app/shared/components/app-loader/app-loader.component.scss */
:host {
  margin: auto;
}
.spinner {
  width: 60px;
  text-align: center;
  display: inline-block;
}
.spinner > div {
  width: 10px;
  height: 10px;
  background-color: #10069F;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.spinner .bounce1 {
  animation-delay: -0.32s;
}
.spinner .bounce2 {
  animation-delay: -0.16s;
}
@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
/*# sourceMappingURL=app-loader.component.css.map */
